import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices/DomainServicesContext";
import {
  type SessionRecord,
  type UpdateSessionRequest,
} from "@/shared/domain/sessions";

import { sessionQueryKeys } from "./sessionQueryKeys";

export interface UseUpdateSessionVariables {
  sessionId: string;
  updates: UpdateSessionRequest;
}

export function useUpdateSession() {
  const { sessionService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<SessionRecord, Error, UseUpdateSessionVariables>({
    mutationFn: ({ sessionId, updates }) =>
      sessionService.updateSession(sessionId, updates),
    onSuccess: (record) => {
      queryClient.setQueryData(
        sessionQueryKeys.detail(record.session_id),
        record,
      );
      // Cached session lists hold their own copy of the record; invalidate
      // them all so the edit shows up wherever sessions are listed.
      void queryClient.invalidateQueries({
        queryKey: sessionQueryKeys.lists(),
      });
    },
  });
}
